import { onlyAccept, required } from '../helpers'
import { ValidationFunctions } from '../types'

export const checkboxEligibility: ValidationFunctions = {
  _self: {
    required,
    onlyAccept,
  },
}
